import { setPersistedAtValue } from "../../../actions/digitalOnboarding/persistedAt";

export const digitalOnboardingPersistedAt = (store, next, action) => {
    const result = next(action);
    store.dispatch(setPersistedAtValue());
    return result;
}